import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'Services/Features/User/Utils/userUtils';
import { setSetupOrder } from 'Services/Features/Order/orderSlice';

const SelectUserOrder = () => {
    const dispatch = useDispatch();
    const dataSetupOrder = useSelector(state => state.order.setupOrder);
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
        const selectedUser = dataSetupOrder.user_id ? {
            value: dataSetupOrder.user_id,
            label: dataSetupOrder.user_name
        } : null;
        setSelectedValue(selectedUser);
    }, [dataSetupOrder.user_id, dataSetupOrder.user_name]);

    const handleChangeUser = (selectedOption) => {
        setSelectedValue(selectedOption === null ? '' : selectedOption);
        dispatch(setSetupOrder({ 
            user_id: selectedOption === null ? '' : selectedOption.value,
            user_name: selectedOption === null ? '' : selectedOption.label
        }));
    };

    const promiseOptionUser = (inputValue, callback) => {
        dispatch(getUser({
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map(item => ({
                    value: item.id,
                    label: item.name + (item.email ? ` (${item.email})` : ''), // Tambahkan email jika ada
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptionUser}
            handleChange={(selectedOption) => handleChangeUser(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Pengguna"
            isMulti={false}
        />
    )
}

export default SelectUserOrder;
